<template>
    <div id="SupplyChainCarousel" class="CompanyCarousel">
        <i tabindex="0" role="button" class="icon-left handle" @keypress.enter="prevCarouselHandler" @click="prevCarouselHandler"></i>
        <div v-if="companyList[0]" class="mid">
            <ul class="carousel-group">
                <li
                    v-for="(item, index) in companyList"
                    :key="companyListName + '-' + index"
                    class="carousel-card-group"
                    :class="{
                        fadeInUp: activatedCarousel === index,
                        fadeOutDown: activatedCarousel !== index,
                    }"
                >
                    <aside>
                        <div class="img-wrap">
                            <img v-if="item.company.logoUrl" :src="item.company.logoUrl" :alt="item.company.name + 'Logo'" />
                        </div>
                        <h3>{{ item.company.name }}</h3>
                        <ul class="table">
                            <li>
                                <span class="head">聯絡窗口</span>
                                <span class="body">
                                    {{ item.contact.department + item.contact.name + item.contact.jobTitle + '\n' + item.contact.phone + '\n' + item.contact.email }}
                                </span>
                            </li>
                            <li v-if="item.recycle && item.recycle.types">
                                <span class="head">處理材質</span>
                                <span class="body">
                                    {{ item.recycle.types.join('、') }}
                                </span>
                            </li>
                            <li v-if="item.recycle && item.recycle.allowedRange">
                                <span class="head">收受區域</span>
                                <span class="body">{{ item.recycle.allowedRange }}</span>
                            </li>
                            <li v-if="item.recycle && item.recycle.allowedStandard">
                                <span class="head">允收標準</span>
                                <span class="body">{{ item.recycle.allowedStandard }}</span>
                            </li>
                            <li v-if="item.product && item.product.types">
                                <span class="head">產品類型</span>
                                <span class="body">
                                    {{ item.product.types.join('、') }}
                                </span>
                            </li>
                        </ul>
                    </aside>
                    <main>
                        <p class="p1" v-for="(paragraph, subindex) in item.company.introduction.split('\n')" :key="item.company.name + '-' + subindex">
                            {{ paragraph }}
                        </p>
                    </main>
                </li>
            </ul>
        </div>
        <div v-else class="mid no-data">
            <h3>尚無合作業者</h3>
        </div>
        <i tabindex="0" role="button" class="icon-right handle" @keypress.enter="nextCarouselHandler" @click="nextCarouselHandler"></i>
    </div>
</template>
<script>
import { ref } from 'vue'
export default {
    name: 'SupplyChainCarousel',
    props: {
        companyList: Array,
        companyListName: String,
    },
    setup(props) {
        const activatedCarousel = ref(0)
        function nextCarouselHandler() {
            if (activatedCarousel.value === props.companyList.length - 1) {
                activatedCarousel.value = 0
            } else activatedCarousel.value += 1
        }
        function prevCarouselHandler() {
            if (activatedCarousel.value === 0) {
                activatedCarousel.value = props.companyList.length - 1
            } else activatedCarousel.value -= 1
        }

        return {
            activatedCarousel,
            nextCarouselHandler,
            prevCarouselHandler,
        }
    },
}
</script>
<style lang="scss" scoped>
.CompanyCarousel {
    display: none;
    height: 0;
    background-color: $grayF;
    overflow: hidden;
    transition: 0.3s;
}
i.handle {
    flex: 1 1 120px;

    display: flex;
    align-items: center;
    padding: 0 30px;
    box-sizing: border-box;

    color: $white;
    font-size: 100px;

    cursor: pointer;
    transition: 0.3s;

    &.icon-left {
        text-align: right;
    }
    &.icon-right {
        text-align: left;
    }

    &:hover,
    &:focus {
        color: $grayD;
    }
}
.carousel-group {
    position: relative;

    .carousel-card-group {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 50px 30px;
        box-sizing: border-box;
    }
    aside {
        flex: 0 1 350px;
        .img-wrap {
            margin: 0 auto;
            width: 240px;
            height: 240px;
            border-radius: 50%;
            background-color: $white;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                position: relative;
                top: 2%;
                max-width: 80%;
                max-height: 80%;
            }
        }
        h3 {
            margin: 30px 0;
            color: $gray6;
            text-align: center;
            font-size: 28px;
            font-weight: 700;
            line-height: 1.5em;
            letter-spacing: 0.05em;
        }
    }
    main {
        margin-left: 45px;
        padding: 80px 0 0;
        flex: 1 3 500px;
        color: $gray2;
    }
}
.mid {
    flex: 0 1 $width1;

    &.no-data {
        text-align: center;
        color: $gray6;
        font-size: 36px;
        font-weight: 700;
        line-height: 300px;
        letter-spacing: 0.05em;
    }
}
</style>
